import { useRef, useState } from 'react'
import { Tooltip } from './Tooltip'
import './truncated.css'

/**
 * Text held to one line, ending in an ellipsis where it runs out of room, and
 * shown whole on hover.
 *
 * The whole text is offered only when the line is actually clipped: a label
 * repeating exactly what is already on screen is noise over the row beneath.
 * Whether it is clipped is asked at the moment of hovering, since that depends
 * on the width the column was handed, not on the text.
 */
export function Truncated({ text }: { text: string }) {
  const ref = useRef<HTMLSpanElement>(null)
  const [clipped, setClipped] = useState(false)
  return (
    <Tooltip label={text} quiet={!clipped} block>
      <span
        ref={ref}
        className="truncated"
        onPointerEnter={() => {
          const el = ref.current
          setClipped(!!el && el.scrollWidth > el.clientWidth)
        }}
      >
        {text}
      </span>
    </Tooltip>
  )
}
